import { AlertProps } from "@mui/material";
import { JobEmployeeProps } from "../interface/job_board";
import { CreateEmployeeAppraisalProps } from "../interface/employment";

export function validateEmploeeApplication(
  form: JobEmployeeProps,
  showNotification: (
    message: string,
    severity?: AlertProps["severity"]
  ) => void,
  jobType: string,
  employmentType: string
): boolean {
  // Validate salary (must be a positive number)
  if (!form.salary) {
    showNotification("Salary is required", "error");
    return false;
  }

  if (!form.start_date) {
    showNotification("Start date is required", "error");
    return false;
  }
  if (jobType === "temporary") {
    if (!form.contract_duration) {
      showNotification("Contract duration is required", "error");
      return false;
    }
  }
  if (employmentType?.toLowerCase() === "locum") {
    if (!form.end_date) {
      showNotification("End date is required", "error");
      return false;
    }
  }

  return true;
}

export function validataPostJobForm(
  form,
  showNotification: (message: string, severity?: AlertProps["severity"]) => void
): boolean {
  // Validate required fields
  if (!form.job_title) {
    showNotification("Job title is required", "error");
    return false;
  }

  if (!form.job_description) {
    showNotification("Job description is required", "error");
    return false;
  }
  if (!form.how_to_apply) {
    showNotification("How to apply is required", "error");
    return false;
  }
  if (!form.experience_level) {
    showNotification("Experience level is required", "error");
    return false;
  }
  if (!form.work_schedule) {
    showNotification("Work schedule is required", "error");
    return false;
  }
  if (!form.job_type) {
    showNotification("Job Type is required", "error");
    return false;
  }
  if (!form.department) {
    showNotification("Department is required", "error");
    return false;
  }
  if (!form.qualifications) {
    showNotification("Qualifications is required", "error");
    return false;
  }
  if (!form.employment_type) {
    showNotification("Employment Type is required", "error");
    return false;
  }
  if (!form.employment_type) {
    showNotification("Work Type is required", "error");
    return false;
  }
  if (!form.salary_range) {
    showNotification("Salary is required", "error");
    return false;
  }
  if (!form.application_deadline) {
    showNotification("Application Deadline  is required", "error");
    return false;
  }
  if (form.external_link) {
    const externalLink = form.external_link.trim();
    const normalizedExternalLink = /^https?:\/\//i.test(externalLink)
      ? externalLink
      : `https://${externalLink}`;

    try {
      new URL(normalizedExternalLink);
    } catch {
      showNotification("External application link is invalid", "error");
      return false;
    }
  }
  if (form.required_documents?.length <= 0) {
    showNotification("Document must be selected", "error");
    return false;
  }

  if (form.job_type === "temporary") {
    if (form.contract_duration?.length < 10) {
      showNotification("Salary is required", "error");
      return false;
    }
  }

  // Additional info is optional, no validation required
  return true; // If all validations pass
}

export function validateEmploeeComment(
  form: CreateEmployeeAppraisalProps,
  strengths: string[],
  showNotification: (message: string, severity?: AlertProps["severity"]) => void
): boolean {
  // Validate salary (must be a positive number)

  if (strengths?.length <= 0) {
    showNotification("Strengths is required", "error");
    return false;
  }
  if (form?.performance_rating === 0) {
    showNotification("Performance Rating is required", "error");
    return false;
  }
  if (!form?.comment) {
    showNotification("Comment is required", "error");
    return false;
  }
  if (!form?.goals) {
    showNotification("Goals is required", "error");
    return false;
  }
  if (!form?.overall_summary) {
    showNotification("Overall summary is required", "error");
    return false;
  }
  if (!form?.appraisal_type) {
    showNotification("Appraisal type is required", "error");
    return false;
  }

  return true;
}
